import React, { useEffect, useState } from 'react';
import { withRouter, Link } from "react-router-dom";
import RolesApi from '../../Services/Roles';
import Alert from '../../Services/Alert';

export const RoleList = (props) => {
    const [data, setData] = useState([]);

    function getRoles() {
        RolesApi.list().then(resp => {
            const r = resp.data;
            if (r.status == 1) setData(r.data);
            else Alert.error(r.message);
        }).catch(e => Alert.error(e.message));
    }

    function onDelete(role) {
        if (role.is_system) { Alert.error('This role is required by the system and cannot be deleted'); return; }
        Alert.warning(`Delete the role "${role.name}"?`).then((result) => {
            if (!result.isConfirmed) return;
            RolesApi.remove(role._id).then(res => res.data).then(res => {
                if (res.status) { Alert.success(res.message); getRoles(); }
                else Alert.error(res.message);
            }).catch(e => Alert.error(e.message));
        });
    }

    useEffect(() => { getRoles(); }, []);

    return (
        <section className="main-content marketadd_main_sec">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="header-text d-flex justify-content-between align-items-center mb-4">
                                        <h4 className="card-title mb-0">Roles</h4>
                                        <Link to="/roles/add" className="btn btn-primary btn-sm">+ Add Role</Link>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Users</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data && data.length > 0 ? data.map((role, key) => (
                                                    <tr key={key}>
                                                        <td>{role.name}{role.is_system ? <span className="badge bg-secondary ms-2">system</span> : null}</td>
                                                        <td>{role.user_count}</td>
                                                        <td>
                                                            <Link to={`/roles/edit/${role._id}`} className="btn btn-sm btn-outline-primary me-2">Edit</Link>
                                                            <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(role)}>Delete</button>
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr><td colSpan="3" className="text-center">No roles yet</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default withRouter(RoleList);
